module.exports = __webpack_public_path__ + "img/goods-1.5d720726.png";